module.exports = require('./url-info.js');


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/urlinfo/index.js
 **/